export default __webpack_public_path__ + "static/media/blog-seach-nav.1fd6514f.svg";